module.exports = __webpack_public_path__ + "img/notebook-monitor.79f2b1f8.png";